import React from 'react'

const Advisor2 = () => {
  return (
<section className="w-full">
  {/* Full Background Image Section */}
  <div
    className="w-full h-[850px] bg-cover "
    style={{
      backgroundImage:
        "url('https://res.cloudinary.com/dzngpgki4/image/upload/v1744986421/image_mnawwp.png')",
    }}
  ></div>

  {/* Box below the image */}
  <div
    className="w-full h-[223px] bg-[#152C24] rounded-b-[5px] md:px-20 md:pt-5 md:pb-5" 
  >
    <h1 className='text-white font-medium md:text-[48px]'>
    Allan Oyier
    </h1>
    <h1 className='text-white font-extrabold md:text-[64px] md:mt-1'>
    Founder & CEO
    </h1>
  </div>

  {/* Paragraph Section */}
  <div className="w-full bg-[#2E453D] px-6 md:px-20 py-16">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">

  <p className="md:mb-10 mb-5">
  Held various roles with 4 leading Global companies, working out of Africa. 
Vice President for leading German Technology Company, Director East and Central Africa for leading Korean Technology Company, Region Manager for leading Swiss Food company, Operations Marketing Manager for leading American Soft Drinks company.      
Experienced in Market development, Strategy building, Go to Market development, Business & Financial Planning, Operations and Projects management.                                                                        
<p className='md:mt-16 mt-10 ` '>
Following in the footsteps of his late father Peter Oyier who was a leading Agriculturalist and leveraging his food & technology experience, he founded the Farmers Networks App Plc.

</p>
  </p>

 

</div>

  <div className='md:mt-40 mt-10'></div>
</div>

  </div>
</section>

  )
}

export default Advisor2